import { useState, useCallback, Fragment } from "react";
import { Button, Modal, message, Tooltip } from "antd";
import { ApiOutlined } from "@ant-design/icons";
import { announcement as announcementService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function AnnouncementPublishButton({
  messageId,
  callback,
  column_name,
  relation_label,
  title,
}) {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const auth = useAuthContext();
  const clickHandler = useCallback(() => {
    setVisible(true);
  }, [setVisible]);
  const okHandler = useCallback(() => {
    setLoading(true);
    announcementService
      .publishAnnouncement(messageId, auth.token)
      .then(() => {
        message.success("操作成功");
        callback(Date.now());
      })
      .finally(() => {
        setVisible(false);
        setLoading(false);
      });
  }, [messageId, callback, auth]);
  const cancelHandler = useCallback(() => {
    setVisible(false);
    setLoading(false);
  }, [setVisible]);
  return (
    <Fragment>
      <Tooltip title="发布">
        <Button size="small" icon={<ApiOutlined />} onClick={clickHandler} />
      </Tooltip>
      <Modal
        title="确认提交"
        visible={visible}
        onOk={okHandler}
        onCancel={cancelHandler}
        okButtonProps={{ loading }}
        okText="确认"
        cancelText="取消"
      >
        <p>栏目：{column_name}</p>
        <p>标题：{title}</p>
        <p>接收单位： {relation_label}</p>
      </Modal>
    </Fragment>
  );
}

export default AnnouncementPublishButton;
